import nl from './nl.json';
import be from './be.json';

export const defaultLocale = 'nl';

export const languages = {
  nl: nl,
  be: be,
}
